import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { sendActivityDetailVirtualPage } from '../../googleTagManager';
import {
  getDayLabel,
  getQuantity,
  swimmingPage,
  updateBookedEntertainments,
  itWasBookedItem,
  getSelectedEntertainment,
  deleteEntertainmentsInCategory,
  handleDeleteEntertainment,
} from '../../utils';
import DineAroundOptions from '../dineAroundOptions/DineAroundOptions';
import '../entertainment/Entertainment.scss';

const isExistsSameDineAround = (selectedActivityId = '', name = '', bookedEntertainmentsWithoutPastEvents = []) => {
  if (selectedActivityId === '' || !bookedEntertainmentsWithoutPastEvents || bookedEntertainmentsWithoutPastEvents.length === 0 || !name) {
    return false;
  }
  return bookedEntertainmentsWithoutPastEvents.filter(({ activityId }) => activityId === selectedActivityId).length > 0;
};

const handleSaveDineAround = async (
  selectedTimeslots,
  selectedEntertainment,
  resId,
  siteCode,
  deleteEntertainment,
  getBookedEntertainments,
  saveEntertainment,
  getAvailableEntertainments,
  history,
  numOfUnits,
  bookedEntertainmentsWithoutPastEvents,
) => {
  await deleteEntertainmentsInCategory({
    selectedEntertainment,
    resId,
    siteCode,
    deleteEntertainment,
    bookedEntertainmentsWithoutPastEvents,
    selectedTimeslots,
  });
  const { activityId, date, name, slots = [] } = selectedEntertainment;
  const entertainmentsToSave = selectedTimeslots.map(({ slotId: timeSlotId, guestNumber = 1 }) => {
    const [{ singleDate: selectedFullDate, duration }] = slots.filter(({ code }) => code === timeSlotId);
    return {
      resId,
      siteCode,
      activityId,
      date,
      name,
      timeSlotId,
      quantity: getQuantity(name, numOfUnits, guestNumber),
      selectedFullDate,
      duration,
      needToReportToGTM: !itWasBookedItem(bookedEntertainmentsWithoutPastEvents, timeSlotId),
      reportType: isExistsSameDineAround(activityId, name, bookedEntertainmentsWithoutPastEvents) ? 'edit' : 'book',
    };
  });
  await saveEntertainment(entertainmentsToSave, 'Dinearound');
  await updateBookedEntertainments(resId, siteCode, getBookedEntertainments, getAvailableEntertainments);
  history.goBack();
};

const getPageTitle = ({ date }, title) => {
  if (date) return getDayLabel(date);
  return title;
};

const getDineAroundOptions = (selectedEntertainment = {}) => (selectedEntertainment.slots
  && selectedEntertainment.slots.length > 0 ? selectedEntertainment.slots : []);

const DineAroundDetail = ({
  title = '',
  subTitle = '',
  dineAroundItems,
  resId = 0,
  siteCode = '',
  getAvailableEntertainments = () => { },
  dineAroundId = '',
  bookedEntertainmentsWithoutPastEvents = [],
  shouldFetchBookedEntertainments = false,
  saveEntertainment = () => { },
  deleteEntertainment = () => { },
  getBookedEntertainments = () => { },
  shouldFetchAvailableEntertainments,
  shouldSkip,
  separatorLabel = '',
  optionTitle = '',
  bookedEvents = [],
  numOfUnits,
  numOfGuests,
  arrivalDate,
  openVenuesForBreakfast,
  openVenuesForDinner,
  refreshTimeInterval,
  lastConfigCheckDateTime,
  breakfastCutoff,
  afternoonCutoff,
  afternoonStartTime,
  afternoonEndTime,
  eveningCutoff,
  eveningStartTime,
  eveningEndTime,
}) => {
  const history = useHistory();
  const [selectedEntertainment, setSelectedEntertainment] = useState({});
  const [checkedEntertainmentSlots, setCheckedEntertainmentSlots] = useState([]);
  const [previousNameToVirtualPage, setPreviousNameToVirtualPage] = useState('');

  useEffect(() => {
    if (shouldSkip) history.push(swimmingPage);
  }, [shouldSkip, history]);

  useEffect(() => {
    const { name } = selectedEntertainment;
    if (name) sendActivityDetailVirtualPage(name, previousNameToVirtualPage, setPreviousNameToVirtualPage);
  }, [selectedEntertainment, previousNameToVirtualPage]);

  useEffect(() => {
    if (shouldFetchAvailableEntertainments) getAvailableEntertainments(siteCode);
  }, [
    shouldFetchAvailableEntertainments,
    getAvailableEntertainments,
    siteCode,
  ]);

  useEffect(() => {
    if (shouldFetchBookedEntertainments) getBookedEntertainments(resId, siteCode);
  }, [
    resId,
    siteCode,
    shouldFetchBookedEntertainments,
    getBookedEntertainments,
  ]);

  useEffect(() => {
    if (dineAroundItems
      && dineAroundItems.length > 0
      && dineAroundId !== ''
      && openVenuesForBreakfast
      && openVenuesForDinner
    ) {
      const cutsEntertainmentId = dineAroundId.split('-');
      const dateIndex = cutsEntertainmentId[0];
      if (dateIndex) {
        const filteredEvent = { ...dineAroundItems[dateIndex].events.find(event => event.code === dineAroundId) };
        const event = getSelectedEntertainment(filteredEvent, openVenuesForBreakfast, openVenuesForDinner);
        setSelectedEntertainment(event);
      }
    }
    if (dineAroundId === '') {
      setSelectedEntertainment({});
      setCheckedEntertainmentSlots([]);
    }
  }, [
    setSelectedEntertainment,
    dineAroundItems,
    setCheckedEntertainmentSlots,
    dineAroundId,
    openVenuesForBreakfast,
    openVenuesForDinner,
  ]);

  useEffect(() => {
    if (bookedEntertainmentsWithoutPastEvents
      && selectedEntertainment
      && selectedEntertainment.slots
      && selectedEntertainment.slots.length > 0
    ) {
      const bookedSlots = selectedEntertainment.slots
        .filter(({ code }) => {
          const bookedEntertainment = bookedEntertainmentsWithoutPastEvents.find(({ TimeSlotId: timeSlotId }) => code === timeSlotId);
          return !!bookedEntertainment;
        })
        .map(({ code }) => parseInt(code, 10));

      setCheckedEntertainmentSlots(bookedSlots);
    }
  }, [
    bookedEntertainmentsWithoutPastEvents,
    getBookedEntertainments,
    resId,
    siteCode,
    selectedEntertainment,
    setCheckedEntertainmentSlots,
    shouldFetchBookedEntertainments,
  ]);

  const showOptions = !(dineAroundId === '' && !!dineAroundItems);
  const options = getDineAroundOptions(selectedEntertainment);

  return (
    <div>
      <div className="entertainment-main-container notSummaryPage">
        <div className="titles">
          <div className="title">{getPageTitle(selectedEntertainment, title)}</div>
          <div className="sub-title">{(!!selectedEntertainment && selectedEntertainment.name) ? selectedEntertainment.name : subTitle}</div>
        </div>
        <div className="entertainments notSummaryPage">
          {showOptions && (
            <DineAroundOptions
              title={optionTitle}
              separatorLabel={separatorLabel}
              options={options}
              saveAddon={selectedTimeslots => handleSaveDineAround(
                selectedTimeslots,
                selectedEntertainment,
                resId,
                siteCode,
                deleteEntertainment,
                getBookedEntertainments,
                saveEntertainment,
                getAvailableEntertainments,
                history,
                numOfUnits,
                bookedEntertainmentsWithoutPastEvents,
              )}
              removeAddon={() => handleDeleteEntertainment(
                selectedEntertainment,
                resId,
                siteCode,
                deleteEntertainment,
                getBookedEntertainments,
                getAvailableEntertainments,
                bookedEntertainmentsWithoutPastEvents,
              )}
              bookedSlotsOfThisEvent={checkedEntertainmentSlots}
              bookedEvents={bookedEvents}
              quantityToBook={getQuantity(selectedEntertainment.name, numOfUnits, numOfGuests)}
              arrivalDate={arrivalDate}
              selectedEntertainment={selectedEntertainment}
              refreshTimeInterval={refreshTimeInterval}
              lastConfigCheckDateTime={lastConfigCheckDateTime}
              breakfastCutoff={breakfastCutoff}
              afternoonCutoff={afternoonCutoff}
              afternoonStartTime={afternoonStartTime}
              afternoonEndTime={afternoonEndTime}
              eveningCutoff={eveningCutoff}
              eveningStartTime={eveningStartTime}
              eveningEndTime={eveningEndTime}
            />
          )}
        </div>
      </div>
    </div>

  );
};

DineAroundDetail.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  dineAroundItems: PropTypes.array,
  resId: PropTypes.number,
  siteCode: PropTypes.string,
  dineAroundId: PropTypes.string,
  getAvailableEntertainments: PropTypes.func,
  bookedEntertainmentsWithoutPastEvents: PropTypes.array,
  shouldFetchBookedEntertainments: PropTypes.bool,
  saveEntertainment: PropTypes.func,
  deleteEntertainment: PropTypes.func,
  getBookedEntertainments: PropTypes.func,
  shouldFetchAvailableEntertainments: PropTypes.bool,
  shouldSkip: PropTypes.bool,
  separatorLabel: PropTypes.string,
  optionTitle: PropTypes.string,
  bookedEvents: PropTypes.array,
  numOfUnits: PropTypes.number,
  numOfGuests: PropTypes.number,
  arrivalDate: PropTypes.string,
  openVenuesForBreakfast: PropTypes.array,
  openVenuesForDinner: PropTypes.array,
  refreshTimeInterval: PropTypes.number,
  lastConfigCheckDateTime: PropTypes.string,
  breakfastCutoff: PropTypes.string,
  afternoonCutoff: PropTypes.string,
  afternoonStartTime: PropTypes.string,
  afternoonEndTime: PropTypes.string,
  eveningCutoff: PropTypes.string,
  eveningStartTime: PropTypes.string,
  eveningEndTime: PropTypes.string,
};

export default DineAroundDetail;
